import {createSlice, PayloadAction, SliceCaseReducers} from '@reduxjs/toolkit';
import {AppActions} from '../../actions';
import {ProductResponsePayload} from '../../../shared/models/api/productResponsePayload';
import {ProductCategoryResponsePayload} from '../../../shared/models/api/productCategoryResponsePayload';
import {ProductAcceptorResponsePayload} from '../../../shared/models/api/productAcceptorResponsePayload';
import {ProductDetailedResponsePayload} from '../../../shared/models/api/productDetailedResponsePayload';

export interface ProductsState {
  list: ProductResponsePayload[] | null;
  listProductCategories: ProductCategoryResponsePayload[] | null;
  listProductAcceptors: ProductAcceptorResponsePayload[] | null;
  detailedProduct: ProductDetailedResponsePayload | undefined;
}

const initialState: ProductsState = {
  list: [],
  listProductCategories: [],
  listProductAcceptors: [],
  detailedProduct: undefined,
};

export const productsSlice = createSlice<ProductsState, SliceCaseReducers<ProductsState>>({
  name: '@@eskso/products',
  initialState,
  reducers: {
    setProducts: (state, action: PayloadAction<ProductResponsePayload[]>) => {
      state.list = action.payload;
    },
    setListProductCategories: (state, action: PayloadAction<ProductCategoryResponsePayload[]>) => {
      state.listProductCategories = action.payload;
    },
    setListProductAcceptors: (state, action: PayloadAction<ProductAcceptorResponsePayload[]>) => {
      state.listProductAcceptors = action.payload;
    },
    setDetailedProduct: (state, action: PayloadAction<ProductDetailedResponsePayload>) => {
      state.detailedProduct = action.payload;
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const products = productsSlice.reducer;
